export default function PageHero({ eyebrow, title, lead, image, alt }) {
  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-ivory via-sage-light/30 to-ivory py-16 lg:py-24" data-testid="page-hero">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className={`grid grid-cols-1 ${image ? "lg:grid-cols-2" : ""} gap-12 items-center`}>
          <div className="animate-fade-up">
            {eyebrow && (
              <p className="text-xs font-sans font-bold tracking-[0.15em] uppercase text-teal mb-4">{eyebrow}</p>
            )}
            <h1 className="text-4xl sm:text-5xl font-serif font-bold tracking-tight text-navy leading-[1.15] text-balance">{title}</h1>
            {lead && <p className="mt-6 text-lg sm:text-xl font-sans text-mutedink leading-relaxed max-w-2xl">{lead}</p>}
          </div>
          {image && (
            <div className="relative animate-fade-up stagger-2">
              <div className="absolute -top-6 -left-6 w-full h-full rounded-[2rem] bg-sage-light" aria-hidden="true" />
              <img src={image} alt={alt || ""} className="relative rounded-[2rem] w-full h-72 lg:h-96 object-cover shadow-lg" />
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
